import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';

import {
  SectionHeaderComponent,
  TitleMenu,
} from 'src/app/shared/components/section-header/section-header.component';

export type DashboardHeaderKey = 'welcome' | 'roadmap';

const DASHBOARDS: Record<DashboardHeaderKey, { label: string; icon: string; route: string }> = {
  welcome: { label: 'Willkommen', icon: 'chart-bar', route: '/dashboard/welcome' },
  roadmap: { label: 'Roadmap & Releasenotes', icon: 'calendar', route: '/dashboard/roadmap' },
};

/**
 * Kompakter Seitenkopf der Dashboard-Seiten (ersetzt die Breadcrumb, Routen
 * setzen dazu `data: { breadcrumb: null }`). Der Titel ist ein Switcher, über
 * den zwischen Willkommen- und Roadmap-Dashboard gewechselt wird.
 */
@Component({
  selector: 'app-dashboard-header',
  standalone: true,
  imports: [SectionHeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="dashboard-header">
      <app-section-header
        size="compact"
        [icon]="config.icon"
        [iconProminent]="true"
        [title]="config.label"
        [titleMenu]="titleMenu"
        (titleMenuSelect)="onSelect($event)">
        <ng-content select="[sectionHeaderActions]" />
      </app-section-header>
    </div>
  `,
  styles: [`
    .dashboard-header {
      min-height: 56px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 4px 0 12px;
    }
    app-section-header { flex: 1; min-width: 0; }
  `],
})
export class DashboardHeaderComponent {
  @Input() active: DashboardHeaderKey = 'welcome';

  private readonly router = inject(Router);

  protected get config(): { label: string; icon: string; route: string } {
    return DASHBOARDS[this.active];
  }

  protected get titleMenu(): TitleMenu {
    return {
      value: this.active,
      menuLabel: 'Dashboard wechseln',
      items: [
        { value: 'welcome', label: DASHBOARDS.welcome.label, icon: DASHBOARDS.welcome.icon },
        { value: 'roadmap', label: DASHBOARDS.roadmap.label, icon: DASHBOARDS.roadmap.icon },
      ],
    };
  }

  protected onSelect(value: string): void {
    const target = DASHBOARDS[value as DashboardHeaderKey];
    if (target && value !== this.active) {
      this.router.navigate([target.route]);
    }
  }
}
